import MentoringRequestCard from './MentoringRequestCard.vue';

export * from './types';
export default MentoringRequestCard;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestcard/index.ts